import * as _ from 'underscore';
import { LocalAuthConfiguration } from '../models/user/validation/LocalAuthConfiguration';
import { Module } from '../Module';
import { GetLocalAuthConfigurationRequest } from '../ServerApi/requests/GetLocalAuthConfigurationRequest';
import { ServerService } from './ServerService';

export class LocalAuthenticationConfigurationService {

    private server: ServerService;

    public static $inject = ['ServerService'];

    constructor(server: ServerService) {
        this.server = server;
    }

    public fetchConfiguration(): ng.IPromise<LocalAuthConfiguration> {
        return this.server.sendRequest(new GetLocalAuthConfigurationRequest()).then((result) => {
            if (!result.errors) {
                return LocalAuthConfiguration.loadServerConfig(result);
            } else {
                return LocalAuthConfiguration.default();
            }
        });
    }

}

Module.instance().service('LocalAuthenticationConfigurationService', LocalAuthenticationConfigurationService);
